(function ($) {
  let $menu_trigger = $(".main-menu__trigger");
  let $menu_expandable = $(".main-menu__expandable");
  let $submenu_trigger = $(".main-menu__submenu-trigger");

  let $icon_search =
    '<svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="11" cy="11" r="8" stroke="black" stroke-width="2"/><line x1="16" y1="16" x2="21" y2="21" stroke="black" stroke-width="2" stroke-linecap="round"/></svg>';

  $menu_trigger.click(function (e) {
    e.stopPropagation();
    if ($(this).hasClass("is-active")) {
      closeMenu(this);
    } else {
      openMenu(this);
    }
  });

  $menu_trigger.mouseover(function (e) {
    // Act if desktop nav is visible.
    if ($(window).width() > 1149) {
      openMenu(this);
    }
  });

  $(".main-menu__primary > .menu-list__item").mouseleave(function () {
    // Act if desktop nav is visible.
    if ($(window).width() > 1149) {
      closeAll();
    }
  });

  $(document).ready(function () {
    let active_menu = $("a.is-active").parents(
      ".main-menu__expandable--mobile"
    );
    if (active_menu) {
      toggleSubmenu(active_menu.siblings(".main-menu__submenu-trigger"));
    }
  });

  $(document).click(function (e) {
    if (!$(e.target).closest(".main-menu__expandable").length) {
      closeAll();
    }
  });

  $("#open-main-menu").click(function () {
    $(this).toggleClass("menu-open");
    $(".main-menu").toggleClass("menu-open");
    $(".region-header").toggleClass("mobile-menu-open");

    /* Change search icon on menu open/close */
    if ($(".navigation.menu--main").hasClass("menu-open")) {
      $(".header__right__search").addClass("header__search-visibility");
      $("#header-rekai-search-bar").addClass("header__search--hidden");
      $("#header__search--button-icon-id").html($icon_search);
    } else {
      $(".header__right__search").removeClass("header__search-visibility");
    }
  });

  $("#open-sub-menu").click(function () {
    $(this).toggleClass("menu-open");
    $(
      ".main-menu__level-3 ul li > ul.main-menu--level-3__children"
    ).toggleClass("sub-menu-open");
  });

  $submenu_trigger.click(function (e) {
    toggleSubmenu(this);
  });

  function openMenu(el) {
    closeAll();
    $(el).addClass("is-active");
    $(el).next(".main-menu__expandable").addClass("open");
  }

  function closeMenu(el) {
    $(el).removeClass("is-active");
    $(el).next(".main-menu__expandable").removeClass("open");
  }

  function toggleSubmenu(el) {
    $(el).toggleClass("is-active");
    $(el).next(".main-menu__expandable--mobile").toggleClass("open");
  }

  // Close all menus.
  function closeAll() {
    $menu_expandable.removeClass("open");
    $menu_trigger.removeClass("is-active");
  }
})(jQuery);
